import { Component, OnInit } from "@angular/core";
import { FormGroup, NG_VALUE_ACCESSOR } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { MakeAdjustmentService } from "./make-adjustment.service";
import { FetchBussinesService } from '../../../report/services/fetch-bussines.service';
import { ModalData } from '../../action';
import { TitledModalWithContentService } from '../../../../../shared/services/titled-modal-with-content.service';
import { FormValidatorService } from "../../../../../shared/services/form-validator.service";
import { Validators } from "../../../../../shared/validators";
import { SelectBoxSearchComponent } from "../../../../../shared/components/select-box-search/select-box-search.component";

@Component({
  selector: 'app-make-adjustment',
  templateUrl: './make-adjustment.component.html',
  styleUrls: ['./make-adjustment.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: SelectBoxSearchComponent }]
})
export class MakeAdjustmentComponent implements OnInit {
  state: any;
  options = {
    placement: "top center",
    type: "loader",
    width: 100,
    state: "default",
    message: "Loading..."
  };
  bussineses: any[] = [];
  makeAdjustmentForm!: FormGroup;
  types: any[] = [
    { name: "ADJUSTMENT_CREDIT", id: "credit" },
    { name: "ADJUSTMENT_DEBIT", id: "debit" }
  ];
  defaultValue: any = {};

  constructor(
    public formValidator: FormValidatorService,
    public fetchBussines: FetchBussinesService,
    public maekAdjustment: MakeAdjustmentService,
    private translate: TranslateService,
    private modal: TitledModalWithContentService
  ) { }

  async ngOnInit() {
    this.fetchBussines.setParams({ all: true, sortOptions: { name: "asc" } });
    let response = await this.fetchBussines.make();
    this.bussineses = response.result;
    this.makeAdjustmentForm = this.formValidator.createForm([
      {
        fieldName: "description",
        defaultValue: null
      },
      {
        fieldName: "amount",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "Amount"
            })
          },
          {
            validatorFn: Validators.min(1),
            message: this.translate.instant("FORMS.VALIDATION.MINIMUM", {
              field: "Amount",
              value: 1
            })
          }
        ]
      },
      {
        fieldName: "type",
        defaultValue: "null",
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "Amount"
            })
          }
        ]
      },
      {
        fieldName: "bussinesId",
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant("FORMS.VALIDATION.REQUIRED", {
              field: "Amount"
            })
          }
        ]
      }
    ]);
    if (this.bussineses && this.bussineses.length) {
      this.makeAdjustmentForm.controls["bussinesId"].setValue(this.bussineses[0].id);
      this.defaultValue = {
        id: this.bussineses[0].id,
        description: this.bussineses[0].name
      }
    }
  }

  async onSubmit() {
    console.log(this.makeAdjustmentForm.value);
    this.maekAdjustment.setParams(this.makeAdjustmentForm.value);
    let response = await this.maekAdjustment.make();

    let modalData: ModalData = {
      title: "Make Adjustment",
      content: response.message,
      closeButtonName: "close"
    };
    this.modal.open(modalData);
  }

  async displaySeller(event: number) {
    this.makeAdjustmentForm.controls["bussinesId"].setValue(event);
  }
}
